var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.25H26C26.1989 13.25 26.3897 13.329 26.5303 13.4697C26.671 13.6103 26.75 13.8011 26.75 14V26C26.75 26.1989 26.671 26.3897 26.5303 26.5303C26.3897 26.671 26.1989 26.75 26 26.75H14C13.8011 26.75 13.6103 26.671 13.4697 26.5303C13.329 26.3897 13.25 26.1989 13.25 26V14C13.25 13.8011 13.329 13.6103 13.4697 13.4697C13.6103 13.329 13.8011 13.25 14 13.25ZM14.75 14.75V25.25H25.25V14.75H14.75ZM16.625 17.75C16.3266 17.75 16.0405 17.6315 15.8295 17.4205C15.6185 17.2095 15.5 16.9234 15.5 16.625C15.5 16.3266 15.6185 16.0405 15.8295 15.8295C16.0405 15.6185 16.3266 15.5 16.625 15.5C16.9234 15.5 17.2095 15.6185 17.4205 15.8295C17.6315 16.0405 17.75 16.3266 17.75 16.625C17.75 16.9234 17.6315 17.2095 17.4205 17.4205C17.2095 17.6315 16.9234 17.75 16.625 17.75ZM15.875 18.5H17.375V24.125H15.875V18.5ZM20 18.8225C20.438 18.3988 20.9495 18.125 21.5 18.125C23.0533 18.125 24.125 19.3842 24.125 20.9375V24.125H22.625V20.9375C22.625 20.5894 22.4867 20.2556 22.2406 20.0094C21.9944 19.7633 21.6606 19.625 21.3125 19.625C20.9644 19.625 20.6306 19.7633 20.3844 20.0094C20.1383 20.2556 20 20.5894 20 20.9375V24.125H18.5V18.5H20V18.8225Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIcon4);
export default __webpack_public_path__ + "static/media/connect_icon4.7a12203168f22c7e91a7d2febe562f6a.svg";
export { ForwardRef as ReactComponent };